<template>
    <div style="padding-top: 20px;">
      <div class="main">
          <div>
        <div class="flex_main">
          <div class="flex_title">分享配图</div>
          <div class="flex_title1">分享文案</div>
        </div>
        <div class="flex_main">
          <div class="flex_main_name">英文</div>
          <UploadImage ref="imageEn" @upLoadImage="upLoadImage1"></UploadImage>
          <el-input style="width:500px;margin-left: 20px;" v-model="active.contentEn" placeholder="请输入英文"/>
        </div>
        <div class="flex_main">
          <div class="flex_main_name">西班牙语</div>
          <UploadImage ref="imageEs" @upLoadImage="upLoadImage2"></UploadImage>
          <el-input style="width:500px;margin-left: 20px;" v-model="active.contentEs" placeholder="请输入西班牙语"/>
        </div>
        <div class="flex_main">
          <div class="flex_main_name">法语</div>
          <UploadImage ref="imageFr" @upLoadImage="upLoadImage3"></UploadImage>
          <el-input style="width:500px;margin-left: 20px;" v-model="active.contentFr" placeholder="请输入法语"/>
        </div>
        <div class="flex_main">
          <div class="flex_main_name">德语</div>
          <UploadImage ref="imageDe" @upLoadImage="upLoadImage4"></UploadImage>
          <el-input style="width:500px;margin-left: 20px;" v-model="active.contentDe" placeholder="请输入德语"/>
        </div>
        <div class="flex_main">
          <div class="flex_main_name">葡萄牙语</div>
          <UploadImage ref="imagePt" @upLoadImage="upLoadImage5"></UploadImage>
          <el-input style="width:500px;margin-left: 20px;" v-model="active.contentPt" placeholder="请输入葡萄牙语"/>
        </div>
        <div class="flex_main">
          <div class="flex_main_name">土耳其语</div>
          <UploadImage ref="imageTr" @upLoadImage="upLoadImage6"></UploadImage>
          <el-input style="width:500px;margin-left: 20px;" v-model="active.contentTr" placeholder="请输入土耳其语"/>
        </div>
        <div class="flex_main">
          <div class="flex_main_name">希腊语</div>
          <UploadImage ref="imageGr" @upLoadImage="upLoadImage7"></UploadImage>
          <el-input style="width:500px;margin-left: 20px;" v-model="active.contentGr" placeholder="请输入希腊语"/>
        </div>
        <div class="flex_main">
          <div class="flex_main_name">阿拉伯语</div>
          <UploadImage ref="imageEg" @upLoadImage="upLoadImage8"></UploadImage>
          <el-input style="width:500px;margin-left: 20px;" v-model="active.contentEg" placeholder="请输入阿拉伯语"/>
        </div>
        <div class="flex_main">
          <div class="flex_main_name">意大利语</div>
          <UploadImage ref="imageIt" @upLoadImage="upLoadImage9"></UploadImage>
          <el-input style="width:500px;margin-left: 20px;" v-model="active.contentIt" placeholder="请输入意大利语"/>
        </div>
        <div class="flex_main">
          <div class="flex_main_name">波斯语</div>
          <UploadImage ref="imageIr" @upLoadImage="upLoadImage10"></UploadImage>
          <el-input style="width:500px;margin-left: 20px;" v-model="active.contentIr" placeholder="请输入波斯语"/>
        </div>
        <div class="flex_main">
          <div class="flex_main_name">荷兰语</div>
          <UploadImage ref="imageNl" @upLoadImage="upLoadImage11"></UploadImage>
          <el-input style="width:500px;margin-left: 20px;" v-model="active.contentNl" placeholder="请输入荷兰语"/>
        </div>
        <div class="flex_main">
          <div class="flex_main_name">印地语</div>
          <UploadImage ref="imageIn" @upLoadImage="upLoadImage12"></UploadImage>
          <el-input style="width:500px;margin-left: 20px;" v-model="active.contentIn" placeholder="请输入印地语"/>
        </div>
        <div class="flex_main">
          <div class="flex_main_name">乌兹别克语</div>
          <UploadImage ref="imageUz" @upLoadImage="upLoadImage13"></UploadImage>
          <el-input style="width:500px;margin-left: 20px;" v-model="active.contentUz" placeholder="请输入乌兹别克语"/>
        </div>
        <div class="flex_main">
          <div class="flex_main_name">越南语</div>
          <UploadImage ref="imageVn" @upLoadImage="upLoadImage14"></UploadImage>
          <el-input style="width:500px;margin-left: 20px;" v-model="active.contentVn" placeholder="请输入越南语"/>
        </div>
        <div class="flex_main">
          <div class="flex_main_name">韩语</div>
          <UploadImage ref="imageKr" @upLoadImage="upLoadImage17"></UploadImage>
          <el-input style="width:500px;margin-left: 20px;" v-model="active.contentKo" placeholder="请输入韩语"/>
        </div>
        <div class="flex_main">
          <div class="flex_main_name">印尼语</div>
          <UploadImage ref="imageId" @upLoadImage="upLoadImage18"></UploadImage>
          <el-input style="width:500px;margin-left: 20px;" v-model="active.contentId" placeholder="请输入印尼语"/>
        </div>
        <div class="flex_main">
          <div class="flex_main_name">俄语</div>
          <UploadImage ref="imageRu" @upLoadImage="upLoadImage19"></UploadImage>
          <el-input style="width:500px;margin-left: 20px;" v-model="active.contentRu" placeholder="请输入俄语"/>
        </div>
        <div class="flex_main">
          <div class="flex_main_name">波兰语</div>
          <UploadImage ref="imagePl" @upLoadImage="upLoadImage20"></UploadImage>
          <el-input style="width:500px;margin-left: 20px;" v-model="active.contentPl" placeholder="请输入波兰语"/>
        </div>
        <div class="flex_main">
          <div class="flex_main_name">匈牙利语</div>
          <UploadImage ref="imageHu" @upLoadImage="upLoadImage21"></UploadImage>
          <el-input style="width:500px;margin-left: 20px;" v-model="active.contentHu" placeholder="请输入匈牙利语"/>
        </div>
        <div class="flex_main">
          <div class="flex_main_name">罗马尼亚语</div>
          <UploadImage ref="imageRo" @upLoadImage="upLoadImage22"></UploadImage>
          <el-input style="width:500px;margin-left: 20px;" v-model="active.contentRo" placeholder="请输入罗马尼亚语"/>
        </div>
      </div>
      </div>
      <div style="margin-left: 110px;margin-top: 20px;">
          <el-popconfirm title="确定更新？" @confirm="tieImageUpdate()">
            <el-button
              slot="reference"
              type="primary"
              class="edit-button"
            >更新</el-button>
          </el-popconfirm>
      </div>
    </div>
  </template>
  <script>
  import Pagination from "@/components/Pagination"; // 引入分页器
  import UploadImage from "@/components/Upload/UploadPic"; // 引入分页器
  import VueUeditorWrap from "vue-ueditor-wrap"; // ES6 Module
  
  import validEmail from "@/utils/validate"; // 引入邮箱验证方法
  import md5 from "js-md5"; // 引入Md5加密
  
  export default {
    name: "Management",
    components: { Pagination, VueUeditorWrap, UploadImage },
    data() {
      return {
        option: "", // 初始选项
        options: [], // 选择角色
        name: "", // 搜索的管理员名称
        tableData: [], // 展示的表单信息
        // 添加表单
        active: {},
        // 修改表单
        editForm: {},
        total: 0, // 总数
        pageNum: 1, // 页码值
        pageSize: 20, // 页大小
        multipleSelection: [], // 选中项s
        yiFangDetailList: [], //
        dialogVisible: false, // 添加弹窗
        dialog: false, // 添加弹窗
        edit_dialogVisible: false, // 编辑弹窗
        Isedit: false, // 是否是编辑弹窗
        loading: false, // 表格加
        buttongLoding: false, // 按钮加载
        name: "",
        username: "",
        memo: "",
        isEnabled: false,
        isChat: false,
        isTelegram: false,
        isWhatsApp: false,
        isMessenger: false,
        isLinkUrl: false,
        isTelegramGroup: false,
        dataTime: ["", ""],
        yifangId: "",
      };
    },
    mounted() {
      this.getList();
    },
    methods: {
      upLoadImage1(img) {
        this.active.imageEn = img;
      },
      upLoadImage2(img) {
        this.active.imageEs = img;
      },
      upLoadImage3(img) {
        this.active.imageFr = img;
      },
      upLoadImage4(img) {
        this.active.imageDe = img;
      },
      upLoadImage5(img) {
        this.active.imagePt = img;
      },
      upLoadImage6(img) {
        this.active.imageTr = img;
      },
      upLoadImage7(img) {
        this.active.imageGr = img;
      },
      upLoadImage8(img) {
        this.active.imageEg = img;
      },
      upLoadImage9(img) {
        this.active.imageIt = img;
      },
      upLoadImage10(img) {
        this.active.imageIr = img;
      },
      upLoadImage11(img) {
        this.active.imageNl = img;
      },
      upLoadImage12(img) {
        this.active.imageIn = img;
      },
      upLoadImage13(img) {
        this.active.imageUz = img;
      },
      upLoadImage14(img) {
        this.active.imageVn = img;
      },
      upLoadImage17(img) {
        this.active.imageKo = img;
      },
      upLoadImage18(img) {
        this.active.imageId = img;
      },
      upLoadImage19(img) {
        this.active.imageRu = img;
      },
      upLoadImage20(img) {
        this.active.imagePl = img;
      },
      upLoadImage21(img) {
        this.active.imageHu = img;
      },
      upLoadImage22(img) {
        this.active.imageRo = img;
      },
      handleClickItem() {
        this.$nextTick(() => {
          // 获取遮罩层dom
          const domImageMask = document.querySelector(".el-image-viewer__mask");
          if (!domImageMask) {
            return;
          }
          domImageMask.addEventListener("click", () => {
            // 点击遮罩层时调用关闭按钮的 click 事件
            document.querySelector(".el-image-viewer__close").click();
          });
        });
      },
      // 筛选
      select() {
        this.pageNum = 1;
        this.getList();
      },
      // 获取表单信息
      getList() {
        this.$api.operate
          .shareConfig()
          .then((res) => {
              this.active = res
              this.$nextTick((_) => {
              // VIP广告示意图
                this.$refs.imageEn.init(res.imageEn)
                this.$refs.imageEs.init(res.imageEs)
                this.$refs.imageFr.init(res.imageFr)
                this.$refs.imageDe.init(res.imageDe)
                this.$refs.imagePt.init(res.imagePt)
                this.$refs.imageTr.init(res.imageTr)
                this.$refs.imageGr.init(res.imageGr)
                this.$refs.imageEg.init(res.imageEg)
                this.$refs.imageIt.init(res.imageIt)
                this.$refs.imageIr.init(res.imageIr)
                this.$refs.imageNl.init(res.imageNl)
                this.$refs.imageIn.init(res.imageIn)
                this.$refs.imageUz.init(res.imageUz)
                this.$refs.imageVn.init(res.imageVn)
                this.$refs.imageKr.init(res.imageKo)
                this.$refs.imageId.init(res.imageId)
                this.$refs.imageRu.init(res.imageRu)
                this.$refs.imagePl.init(res.imagePl)
                this.$refs.imageHu.init(res.imageHu)
                this.$refs.imageRo.init(res.imageRo)
              })
  
          })
          .catch((err) => {
            this.$message.error(err || "服务器错误，请稍后重试");
          })
          .finally(() => {
            this.loading = false;
          });
      },
      // 更新
      tieImageUpdate(){
        console.log(this.active)
          this.$api.operate
          .shareConfigUpdate(this.active)
          .then((res) => {
              this.$message.success(res);
          })
          .catch((err) => {
            this.$message.error(err || "服务器错误，请稍后重试");
          })
          .finally(() => {
            this.loading = false;
            this.getList();
          });
      }
    },
  };
  </script>
  <style lang="scss" scoped>
  .flex_main{
      display: flex;
      align-items: center;
      margin-top: 10px;
      
  }
  .flex_main_name{
      width: 100px;
      text-align: end;
      margin-right: 0px;
      font-size: 14px;
      color: #606266;
  }
  .flex_title{
      width: 150px;
      text-align: end;
      font-size: 15px;
      font-weight: 500;
      margin-right: 20px;
  }
  .flex_title1{
      font-size: 15px;
      font-weight: 500;
  
  }
  .main{
      display: flex;
      align-items: center;
      flex-wrap: wrap;
  }
  </style>
  